import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../Common/Modal/Modal';
import { labels, workspaceCreationStatus } from '../../../util/uiconstants';
import Utility from '../../../util/utils';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import TicketField from '../common/ticketfield';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';
import ErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import Loader from '../../Common/Loaders/loadingindicator';
import env from '../../../util/env';
import { addCollaborationSiteWorkspace } from '../../../actions/admin/sharepointworkspacesactions';
import styled from 'styled-components';
import { validateTicketNumber } from '../common/util';

const AddWorkspaceModal = (props) => {
	const {
		showModal,
		defaultDatacenterId,
		onClose
	} = props;

	const dispatch = useDispatch();
	const dataCenterList = useSelector((store) => store.dataCentersSharepointWorkspaces);
	const [dataCenterId, setDataCenterId] = useState(defaultDatacenterId ?? '');
	const [ticketNumber, setTicketNumber] = useState('');
	const [showDataCenterValidation, setShowDataCenterValidation] = useState(false);
	const [showTicketValidation, setShowTicketValidation] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const getDatacenterList = () => {
		return Array.isArray(dataCenterList) ? dataCenterList : [];
	};

	const onDatacenterChange = (id) => {
		setDataCenterId(id);
		setShowDataCenterValidation(false);
	};

	const onTicketChange = (e) => {
		setTicketNumber(e.target.value ?? '');
		setShowTicketValidation(false);
	};

	const validateInput = () => {
		let isValid = true;
		if (dataCenterId === '') {
			setShowDataCenterValidation(true);
			isValid = false;
		}
		if (!validateTicketNumber(ticketNumber)) {
			setShowTicketValidation(true);
			isValid = false;
		}
		return isValid;
	};

	const onSave = () => {
		if (!validateInput()) {
			return;
		}

		setIsLoading(true);
		let url = env.getURL('serviceUrlV2') + `admin/datacenters/${dataCenterId}/collaborationsites`;
		dispatch(addCollaborationSiteWorkspace(url, { ticketNumber }))
			.then(() => {
				onClose({dataCenterId, statusId: workspaceCreationStatus.Success});
			})
			.catch(() => {
				onClose({dataCenterId, statusId: workspaceCreationStatus.Failed});
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const noResultsTemplate = () => (
		<MotifOption disabled>{labels.noResultsFound}</MotifOption>
	);

	return (
		<>
			<Modal
				modalsize="small"
				role="dialog"
				headerText={labels.addWorkspaceModalTitle}
				show={showModal}
				onOkClick={onSave}
				modalContainerClass={'add-workspace-modal'}
				onClose={() => {
					// Handle loading state, as 'disableClose' prop not working
					isLoading ? null : onClose(workspaceCreationStatus.NoAction);
				}}
				isOkButtonDisabled={isLoading}
				isCancelButtonDisabled={isLoading}
				disableClose={isLoading}
				labels={{
					modalConfirmBtnLabel: labels.save,
					modalCancelBtnLabel: labels.cancel,
					modalCloseBtnTitletip: labels.cancel,
					cancel: labels.cancel
				}}
			>
				<AddWorkspaceWrapper>
					{isLoading ? (
						<Loader variant={'circular'} />
					) : (
						<>
							<div className="mainDescription motif-body1-default-light">
								{Utility.createRichTextElement(
									labels.addWorkspaceModalDescription
								)}
							</div>
							<div className="form-field">
								<MotifFormField>
									<MotifLabel id="select-label" position='in'>
										{labels.datacenterLabel}
									</MotifLabel>
									<MotifSelect
										labelPosition="in"
										ariaLabelledBy="select-datacenter-label"
										onChange={onDatacenterChange}
										value={`${dataCenterId}`}
										visibleOptions={7} // to show more options in dropdown
										placeholder={labels.datacenterPlaceholder}
										noResultsTemplate={noResultsTemplate}
									>
										{getDatacenterList().map((dc) => (
											<MotifOption
												key={dc.dataCenterId}
												value={`${dc.dataCenterId}`}
												label={dc.dataCenterName}
											>
												{
													<EllipsesControl
														content={dc.dataCenterName}
														tooltip={dc.dataCenterName}
														noOfLines={1}
													/>
												}
											</MotifOption>
										))}
									</MotifSelect>
									{showDataCenterValidation && (
										<ErrorMessage>{labels.kendoRequiredMessage}</ErrorMessage>
									)}
								</MotifFormField>
							</div>
							<div className="ticket-field">
								<TicketField
									ticketNumber={ticketNumber}
									onTicketChanged={onTicketChange}
									showValidation={showTicketValidation}
									validationMessage={labels.kendoRequiredMessage}
								/>
							</div>
						</>
					)}
				</AddWorkspaceWrapper>
			</Modal>
		</>
	);
};
export default AddWorkspaceModal;

const AddWorkspaceWrapper = styled.section`
	.mainDescription {
		padding: 0 var(--spacing-x-large);
	}
	.form-field {
		padding: var(--spacing-x-large);
	}
	.ticket-field {
		padding: 0 var(--spacing-x-large) var(--spacing-x-large)
			var(--spacing-x-large);
		.description {
			font-size: var(--px-16);
			padding-bottom: var(--spacing-small);
		}
	}
	.motif-progress-loader {
		position: absolute;
		top: 50%;
		left: 50%;
	}
	.motif-form-field {
		width: var(--px-400);
		.motif-input {
			height: var(--px-44);
		}
	}
`;
